
import { environmentExtender } from './environment.extender';

export const environment = environmentExtender({

	name: 'production',

	cashierLoaderUrl: 'https://checkout.{{hostDomain}}/v2/loader',

	googleTagTransportUrl: 'https://analytics.bridgerpay.com',

	merchantAdminUrl: 'https://dash.bridgerpay.com',

	api: 'relative',

});
